

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API } from "../config";
// import "../../style/RectorEleccionesPro.css";

// export default function RectorEleccionesPro() {

//   const token = localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   // ✅ URL uploads correcta
//   const API_UPLOADS = API.replace("/api", "");

//   /* ================= STATES ================= */
//   const [elecciones, setElecciones] = useState([]);

//   const [modal, setModal] = useState(false);
//   const [modalCandidato, setModalCandidato] = useState(false);

//   const [eleccionActiva, setEleccionActiva] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const [candidatos, setCandidatos] = useState([]);

//   /* ================= FORM ELECCIÓN ================= */
//   const [form, setForm] = useState({
//     nombre: "",
//     descripcion: "",
//     dirigida_a: "ESTUDIANTES",
//     fecha_inicio: "",
//     fecha_fin: "",
//     sede_id: ""
//   });

//   /* ================= FORM CANDIDATO ================= */
//   const [formCandidato, setFormCandidato] = useState({
//     nombre: "",
//     numero: "",
//     descripcion: "",
//     foto: null
//   });

//   /* ================= LISTAR ELECCIONES ================= */
//   const fetchElecciones = async () => {
//     try {

//       setError("");

//       const res = await axios.get(
//         `${API}/elecciones`,
//         { headers }
//       );

//       setElecciones(
//         Array.isArray(res.data)
//           ? res.data
//           : []
//       );

//     } catch (err) {
//       console.log(err);
//       setError("Error cargando elecciones");
//     }
//   };

//   useEffect(() => {
//     fetchElecciones();
//   }, []);

//   /* ================= CREAR ELECCIÓN ================= */
//   const crear = async () => {
//     try {

//       setLoading(true);

//       await axios.post(
//         `${API}/elecciones`,
//         form,
//         { headers }
//       );

//       setForm({
//         nombre: "",
//         descripcion: "",
//         dirigida_a: "ESTUDIANTES",
//         fecha_inicio: "",
//         fecha_fin: "",
//         sede_id: ""
//       });

//       setModal(false);

//       fetchElecciones();

//     } catch (err) {

//       console.log(err);
//       setError("Error creando elección");

//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= ACTIVAR ================= */
//   const activar = async (id) => {
//     try {

//       await axios.put(
//         `${API}/elecciones/${id}/activar`,
//         {},
//         { headers }
//       );

//       fetchElecciones();

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   /* ================= CERRAR ================= */
//   const cerrar = async (id) => {
//     try {

//       await axios.put(
//         `${API}/elecciones/${id}/cerrar`,
//         {},
//         { headers }
//       );

//       fetchElecciones();

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   /* ================= VER CANDIDATOS ================= */
//   const verCandidatos = async (eleccion) => {
//     try {

//       const res = await axios.get(
//         `${API}/electionCandidates/${eleccion.id}/candidates`,
//         { headers }
//       );

//       setCandidatos(res.data.data || []);

//       setEleccionActiva(eleccion);

//       setModalCandidato(true);

//     } catch (err) {

//       console.log(err);
//       setError("Error cargando candidatos");

//     }
//   };

//   /* ================= CREAR CANDIDATO ================= */
//   const crearCandidato = async () => {
//     try {

//       setLoading(true);

//       const formData = new FormData();

//       formData.append("nombre", formCandidato.nombre);
//       formData.append("numero", formCandidato.numero);
//       formData.append("descripcion", formCandidato.descripcion);

//       if (formCandidato.foto) {
//         formData.append("foto", formCandidato.foto);
//       }

//       await axios.post(
//         `${API}/electionCandidates/${eleccionActiva.id}/candidates`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         }
//       );

//       // 🔥 RECARGAR CANDIDATOS
//       await verCandidatos(eleccionActiva);

//       // 🔥 LIMPIAR FORM
//       setFormCandidato({
//         nombre: "",
//         numero: "",
//         descripcion: "",
//         foto: null
//       });

//     } catch (err) {

//       console.log(err);
//       setError("Error agregando candidato");

//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= UI ================= */
//   return (
//     <div className="elecciones-container">

//       <h2>🗳️ Elecciones Rector</h2>

//       {error && (
//         <p className="error">
//           {error}
//         </p>
//       )}

//       {/* ================= BOTÓN CREAR ================= */}
//       <button
//         className="btn-primary"
//         onClick={() => setModal(true)}
//       >
//         ➕ Nueva elección
//       </button>

//       {/* ================= LISTADO ================= */}
//       <div className="grid">

//         {elecciones.map((el) => (

//           <div
//             key={el.id}
//             className="card"
//           >

//             <h3>{el.nombre}</h3>

//             <p>{el.descripcion}</p>

//             <p>
//               <b>Estado:</b> {el.estado}
//             </p>

//             <p>
//               <b>Dirigida a:</b> {el.dirigida_a}
//             </p>

//             <div className="actions">

//               {el.estado === "BORRADOR" && (
//                 <button onClick={() => activar(el.id)}>
//                   Activar
//                 </button>
//               )}

//               {el.estado === "ACTIVA" && (
//                 <>
//                   <button onClick={() => cerrar(el.id)}>
//                     Cerrar
//                   </button>

//                   <button onClick={() => verCandidatos(el)}>
//                     👁 Ver / Agregar Candidatos
//                   </button>
//                 </>
//               )}

//             </div>

//           </div>

//         ))}

//       </div>

//       {/* =========================================================
//           MODAL CREAR ELECCIÓN
//       ========================================================= */}
//       {modal && (
//         <div className="modal">

//           <div className="modal-box">

//             <h3>Crear elección</h3>

//             <input
//               type="text"
//               placeholder="Nombre"
//               value={form.nombre}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   nombre: e.target.value
//                 })
//               }
//             />

//             <input
//               type="text"
//               placeholder="Descripción"
//               value={form.descripcion}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   descripcion: e.target.value
//                 })
//               }
//             />

//             <select
//               value={form.dirigida_a}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   dirigida_a: e.target.value
//                 })
//               }
//             >
//               <option value="ESTUDIANTES">
//                 Estudiantes
//               </option>

//               <option value="DOCENTES">
//                 Docentes
//               </option>
//             </select>

//             <input
//               type="datetime-local"
//               value={form.fecha_inicio}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   fecha_inicio: e.target.value
//                 })
//               }
//             />

//             <input
//               type="datetime-local"
//               value={form.fecha_fin}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   fecha_fin: e.target.value
//                 })
//               }
//             />

//             <div className="modal-actions">

//               <button
//                 onClick={crear}
//                 disabled={loading}
//               >
//                 {loading ? "Creando..." : "Crear"}
//               </button>

//               <button
//                 onClick={() => setModal(false)}
//               >
//                 Cancelar
//               </button>

//             </div>

//           </div>

//         </div>
//       )}

//       {/* =========================================================
//           MODAL CANDIDATOS
//       ========================================================= */}
//       {modalCandidato && (
//         <div className="modal">

//           <div className="modal-box">

//             <h3>
//               🧑‍💼 Candidatos - {eleccionActiva?.nombre}
//             </h3>

//             {/* ================= FORMULARIO ================= */}

//             <input
//               type="text"
//               placeholder="Nombre del candidato"
//               value={formCandidato.nombre}
//               onChange={(e) =>
//                 setFormCandidato({
//                   ...formCandidato,
//                   nombre: e.target.value
//                 })
//               }
//             />

//             <input
//               type="number"
//               placeholder="Número"
//               value={formCandidato.numero}
//               onChange={(e) =>
//                 setFormCandidato({
//                   ...formCandidato,
//                   numero: e.target.value
//                 })
//               }
//             />

//             <textarea
//               placeholder="Descripción / Eslogan"
//               value={formCandidato.descripcion}
//               onChange={(e) =>
//                 setFormCandidato({
//                   ...formCandidato,
//                   descripcion: e.target.value
//                 })
//               }
//             />

//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) =>
//                 setFormCandidato({
//                   ...formCandidato,
//                   foto: e.target.files[0]
//                 })
//               }
//             />

//             {/* ================= BOTONES ================= */}

//             <div className="modal-actions">

//               <button
//                 onClick={crearCandidato}
//                 disabled={loading}
//               >
//                 {loading
//                   ? "Guardando..."
//                   : "Guardar candidato"}
//               </button>

//               <button
//                 onClick={() => {
//                   setModalCandidato(false);
//                   setEleccionActiva(null);
//                   setCandidatos([]);
//                 }}
//               >
//                 Cancelar
//               </button>

//             </div>

//             {/* ================= LISTADO ================= */}

//             <div style={{ marginTop: "25px" }}>

//               <h3>
//                 📋 Candidatos Registrados
//               </h3>

//               {candidatos.length === 0 ? (

//                 <p>
//                   No hay candidatos registrados
//                 </p>

//               ) : (

//                 <div className="grid">

//                   {candidatos.map((candidato) => (

//                     <div
//                       key={candidato.id}
//                       className="card"
//                     >

//                       {/* FOTO */}

//                       {candidato.foto && (
//                         <img
//                           src={`${API_UPLOADS}/uploads/candidatos/${candidato.foto}`}
//                           alt={candidato.nombre}
//                           style={{
//                             width: "100%",
//                             height: "220px",
//                             objectFit: "cover",
//                             borderRadius: "10px",
//                             marginBottom: "10px"
//                           }}
//                         />
//                       )}

//                       <h4>
//                         {candidato.nombre}
//                       </h4>

//                       <p>
//                         <b>Número:</b>{" "}
//                         {candidato.numero}
//                       </p>

//                       <p>
//                         {candidato.propuesta}
//                       </p>

//                     </div>

//                   ))}

//                 </div>

//               )}

//             </div>

//           </div>

//         </div>
//       )}

//     </div>
//   );
// }


//

import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import { API } from "../config";

import "../../style/RectorEleccionesPro.css";

export default function RectorEleccionesPro() {

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* =====================================================
     URL UPLOADS
  ===================================================== */
  const API_UPLOADS =
    API.replace("/api", "");

  /* =====================================================
     STATES
  ===================================================== */
  const [elecciones, setElecciones] = useState([]);

  const [modal, setModal] = useState(false);

  const [modalCandidato, setModalCandidato] =
    useState(false);

  const [modalResultados, setModalResultados] =
    useState(false);

  const [eleccionActiva, setEleccionActiva] =
    useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [mensaje, setMensaje] = useState("");

  const [candidatos, setCandidatos] = useState([]);

  const [resultados, setResultados] = useState([]);

  const [ganador, setGanador] = useState(null);

  const [totalVotos, setTotalVotos] = useState(0);

  /* =====================================================
     FORM ELECCIÓN
  ===================================================== */
  const [form, setForm] = useState({
    nombre: "",
    descripcion: "",
    dirigida_a: "ESTUDIANTES",
    fecha_inicio: "",
    fecha_fin: "",
    sede_id: ""
  });

  /* =====================================================
     FORM CANDIDATO
  ===================================================== */
  const [formCandidato, setFormCandidato] =
    useState({
      nombre: "",
      numero: "",
      propuesta: "",
      foto: null
    });

  /* =====================================================
     LISTAR ELECCIONES
  ===================================================== */
  const fetchElecciones = async () => {

    try {

      setError("");

      const res = await axios.get(
        `${API}/elecciones`,
        { headers }
      );

      setElecciones(
        Array.isArray(res.data)
          ? res.data
          : []
      );

    } catch (err) {

      console.log(err);

      setError(
        "Error cargando elecciones"
      );

    }

  };

  useEffect(() => {
    fetchElecciones();
  }, []);

  /* =====================================================
     CREAR ELECCIÓN
  ===================================================== */
  const crear = async () => {

    try {

      setLoading(true);

      setError("");

      setMensaje("");

      await axios.post(
        `${API}/elecciones`,
        form,
        { headers }
      );

      setMensaje(
        "Elección creada correctamente"
      );

      setForm({
        nombre: "",
        descripcion: "",
        dirigida_a: "ESTUDIANTES",
        fecha_inicio: "",
        fecha_fin: "",
        sede_id: ""
      });

      setModal(false);

      fetchElecciones();

    } catch (err) {

      console.log(err);

      setError(
        err?.response?.data?.message ||
        "Error creando elección"
      );

    } finally {

      setLoading(false);

    }

  };

  /* =====================================================
     ACTIVAR
  ===================================================== */
  const activar = async (id) => {

    try {

      await axios.put(
        `${API}/elecciones/${id}/activar`,
        {},
        { headers }
      );

      fetchElecciones();

    } catch (err) {

      console.log(err);

      setError(
        "Error activando elección"
      );

    }

  };

  /* =====================================================
     CERRAR
  ===================================================== */
  const cerrar = async (id) => {

    try {

      const confirmar =
        window.confirm(
          "¿Cerrar elección?"
        );

      if (!confirmar) return;

      await axios.put(
        `${API}/elecciones/${id}/cerrar`,
        {},
        { headers }
      );

      fetchElecciones();

    } catch (err) {

      console.log(err);

      setError(
        "Error cerrando elección"
      );

    }

  };

  /* =====================================================
     VER CANDIDATOS
  ===================================================== */
  const verCandidatos = async (
    eleccion
  ) => {

    try {

      setError("");

      const res = await axios.get(
        `${API}/electionCandidates/${eleccion.id}/candidates`,
        { headers }
      );

      setCandidatos(
        res.data.data || []
      );

      setEleccionActiva(eleccion);

      setModalCandidato(true);

    } catch (err) {

      console.log(err);

      setError(
        "Error cargando candidatos"
      );

    }

  };

  /* =====================================================
     CREAR CANDIDATO
  ===================================================== */
  const crearCandidato = async () => {

    try {

      setLoading(true);

      setError("");

      setMensaje("");

      const formData = new FormData();

      formData.append(
        "nombre",
        formCandidato.nombre
      );

      formData.append(
        "numero",
        formCandidato.numero
      );

      formData.append(
        "propuesta",
        formCandidato.propuesta
      );

      if (formCandidato.foto) {

        formData.append(
          "foto",
          formCandidato.foto
        );

      }

      await axios.post(
        `${API}/electionCandidates/${eleccionActiva.id}/candidates`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      setMensaje(
        "Candidato agregado correctamente"
      );

      setFormCandidato({
        nombre: "",
        numero: "",
        propuesta: "",
        foto: null
      });

      await verCandidatos(
        eleccionActiva
      );

    } catch (err) {

      console.log(err);

      setError(
        err?.response?.data?.message ||
        "Error agregando candidato"
      );

    } finally {

      setLoading(false);

    }

  };

  /* =====================================================
     VER RESULTADOS
  ===================================================== */
 /* =====================================================
   VER RESULTADOS
===================================================== */
const verResultados = async (
  eleccion
) => {

  try {

    setError("");

    const res = await axios.get(
      `${API}/elecciones/${eleccion.id}/resultados`,
      { headers }
    );

    console.log(
      "RESULTADOS:",
      res.data
    );

    /* =================================================
       RESULTADOS
    ================================================= */
    setResultados(
      Array.isArray(
        res.data.resultados
      )
        ? res.data.resultados
        : []
    );

    /* =================================================
       TOTAL VOTOS
    ================================================= */
    setTotalVotos(
      Number(
        res.data.total_votos || 0
      )
    );

    /* =================================================
       GANADOR
    ================================================= */
    if (
      res.data.ganador
    ) {

      setGanador(
        res.data.ganador
      );

    } else if (
      res.data.resultados &&
      res.data.resultados.length > 0
    ) {

      // 🔥 sacar ganador automáticamente
      const ganadorCalculado =
        res.data.resultados[0];

      setGanador({
        nombre:
          ganadorCalculado.nombre || "",
        apellido:
          ganadorCalculado.apellido || "",
        votos:
          ganadorCalculado.votos || 0,
        porcentaje:
          ganadorCalculado.porcentaje || 0
      });

    } else {

      setGanador(null);

    }

    setEleccionActiva(
      eleccion
    );

    setModalResultados(
      true
    );

  } catch (err) {

    console.log(err);

    setError(
      err?.response?.data?.message ||
      "Error cargando resultados"
    );

  }

};

  /* =====================================================
     UI
  ===================================================== */
  return (

    <div className="elecciones-container">

      <h2>
        🗳️ Gestión de Elecciones
      </h2>

      {error && (
        <p className="error">
          {error}
        </p>
      )}

      {mensaje && (
        <p className="success">
          {mensaje}
        </p>
      )}

      {/* =====================================================
         BOTÓN CREAR
      ===================================================== */}

      <button
        className="btn-primary"
        onClick={() => setModal(true)}
      >
        ➕ Nueva elección
      </button>

      {/* =====================================================
         LISTADO
      ===================================================== */}

      <div className="grid">

        {elecciones.length === 0 ? (

          <p>
            No hay elecciones
          </p>

        ) : (

          elecciones.map((el) => (

            <div
              key={el.id}
              className="card"
            >

              <h3>
                {el.nombre}
              </h3>

              <p>
                {el.descripcion}
              </p>

              <p>
                <b>Estado:</b>{" "}
                {el.estado}
              </p>

              <p>
                <b>Dirigida a:</b>{" "}
                {el.dirigida_a}
              </p>

              <div className="actions">

                {el.estado === "BORRADOR" && (
                  <button
                    onClick={() =>
                      activar(el.id)
                    }
                  >
                    🚀 Activar
                  </button>
                )}

                {el.estado === "ACTIVA" && (
                  <>
                    <button
                      onClick={() =>
                        cerrar(el.id)
                      }
                    >
                      🔒 Cerrar
                    </button>

                    <button
                      onClick={() =>
                        verCandidatos(el)
                      }
                    >
                      👥 Candidatos
                    </button>
                  </>
                )}

                {el.estado === "CERRADA" && (
                  <button
                    onClick={() =>
                      verResultados(el)
                    }
                  >
                    📊 Ver resultados
                  </button>
                )}

              </div>

            </div>

          ))

        )}

      </div>

      {/* =====================================================
         MODAL CREAR ELECCIÓN
      ===================================================== */}

      {modal && (

        <div className="modal">

          <div className="modal-box">

            <h3>
              Crear elección
            </h3>

            <input
              type="text"
              placeholder="Nombre"
              value={form.nombre}
              onChange={(e) =>
                setForm({
                  ...form,
                  nombre:
                    e.target.value
                })
              }
            />

            <textarea
              placeholder="Descripción"
              value={form.descripcion}
              onChange={(e) =>
                setForm({
                  ...form,
                  descripcion:
                    e.target.value
                })
              }
            />

            <select
              value={form.dirigida_a}
              onChange={(e) =>
                setForm({
                  ...form,
                  dirigida_a:
                    e.target.value
                })
              }
            >
              <option value="ESTUDIANTES">
                Estudiantes
              </option>

              <option value="DOCENTES">
                Docentes
              </option>
            </select>

            <input
              type="datetime-local"
              value={form.fecha_inicio}
              onChange={(e) =>
                setForm({
                  ...form,
                  fecha_inicio:
                    e.target.value
                })
              }
            />

            <input
              type="datetime-local"
              value={form.fecha_fin}
              onChange={(e) =>
                setForm({
                  ...form,
                  fecha_fin:
                    e.target.value
                })
              }
            />

            <div className="modal-actions">

              <button
                disabled={loading}
                onClick={crear}
              >
                {
                  loading
                    ? "Creando..."
                    : "Crear"
                }
              </button>

              <button
                onClick={() =>
                  setModal(false)
                }
              >
                Cancelar
              </button>

            </div>

          </div>

        </div>

      )}

      {/* =====================================================
         MODAL CANDIDATOS
      ===================================================== */}

      {modalCandidato && (

        <div className="modal">

          <div className="modal-box">

            <h3>
              👥 Candidatos
            </h3>

            <input
              type="text"
              placeholder="Nombre del candidato"
              value={formCandidato.nombre}
              onChange={(e) =>
                setFormCandidato({
                  ...formCandidato,
                  nombre:
                    e.target.value
                })
              }
            />

            <input
              type="number"
              placeholder="Número"
              value={formCandidato.numero}
              onChange={(e) =>
                setFormCandidato({
                  ...formCandidato,
                  numero:
                    e.target.value
                })
              }
            />

            <textarea
              placeholder="Descripción"
              value={formCandidato.propuesta}
              onChange={(e) =>
                setFormCandidato({
                  ...formCandidato,
                  propuesta:
                    e.target.value
                })
              }
            />

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setFormCandidato({
                  ...formCandidato,
                  foto:
                    e.target.files[0]
                })
              }
            />

            <div className="modal-actions">

              <button
                disabled={loading}
                onClick={
                  crearCandidato
                }
              >
                {
                  loading
                    ? "Guardando..."
                    : "Guardar"
                }
              </button>

              <button
                onClick={() => {

                  setModalCandidato(
                    false
                  );

                  setEleccionActiva(
                    null
                  );

                  setCandidatos([]);

                }}
              >
                Cerrar
              </button>

            </div>

            {/* =====================================================
               LISTADO CANDIDATOS
            ===================================================== */}

            <div
              style={{
                marginTop: "25px"
              }}
            >

              <h3>
                📋 Candidatos
              </h3>

              {candidatos.length === 0 ? (

                <p>
                  No hay candidatos
                </p>

              ) : (

                <div className="grid">

                  {candidatos.map((c) => (

                    <div
                      key={c.id}
                      className="card"
                    >

                      {c.foto && (

                        <img
                          src={
                            c.foto.startsWith(
                              "http"
                            )
                              ? c.foto
                              : `${API_UPLOADS}/uploads/candidatos/${c.foto}`
                          }
                          alt={
                            c.nombre
                          }
                          className="candidate-photo"
                          style={{
                            width:
                              "100%",
                            height:
                              "220px",
                            objectFit:
                              "cover",
                            borderRadius:
                              "10px"
                          }}
                        />

                      )}

                      <h4>
                        {c.nombre}
                      </h4>

                      <p>
                        <b>
                          Número:
                        </b>{" "}
                        {c.numero}
                      </p>

                      <p>
                        {c.propuesta}
                      </p>

                    </div>

                  ))}

                </div>

              )}

            </div>

          </div>

        </div>

      )}

      {/* =====================================================
         MODAL RESULTADOS
      ===================================================== */}

      {modalResultados && (

        <div className="modal">

          <div className="modal-box">

            <h3>
              📊 Resultados
            </h3>

            <p>
              <b>
                Total votos:
              </b>{" "}
              {totalVotos}
            </p>

            {ganador && (

              <div className="winner-box">

                <h3>
                  🏆 Ganador
                </h3>

                <h2>
                  {ganador.nombre}
                </h2>

                <p>
                  {ganador.votos} votos
                </p>

                <p>
                  {
                    ganador.porcentaje
                  }%
                </p>

              </div>

            )}

            <div className="grid">


           {resultados.map((r) => (

  <div
    key={r.candidate_id}
    className="card"
  >

    {r.foto && (

      <img
        src={
          r.foto.startsWith(
            "http"
          )
            ? r.foto
            : `${API_UPLOADS}/uploads/candidatos/${r.foto}`
        }
        alt={r.nombre}
        className="candidate-photo"
        style={{
          width:
            "100%",
          height:
            "220px",
          objectFit:
            "cover",
          borderRadius:
            "10px"
        }}
      />

    )}

    <h3>
      {r.nombre}
    </h3>

    <p>
      <b>
        Número:
      </b>{" "}
      {r.numero}
    </p>

    <p>
      <b>
        Votos:
      </b>{" "}
      {r.votos}
    </p>

    <p>
      <b>
        Porcentaje:
      </b>{" "}
      {r.porcentaje}%
    </p>

  </div>

))}

            </div>

            <div className="modal-actions">

              <button
                onClick={() =>
                  setModalResultados(
                    false
                  )
                }
              >
                Cerrar
              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}